<mat-form-field
  class="outline no-placeholder paddingless expiry-date-field-wrapper"
  appearance="outline"
>
  <mat-select
    (selectionChange)="
      isDatePickerMode = false; onPeriodModifierClick($event.value)
    "
    class="select"
    [(ngModel)]="selectedPeriodModifier"
  >
    <mat-option *ngFor="let modifier of _periodModifiers" [value]="modifier">{{
      'cp.momentPeriodDatepicker.titles.periodModifier-' + modifier | translate
    }}</mat-option>
    <mat-option [value]="'datepicker'" (click)="openDatePicker()"
      >{{
        'cp.momentPeriodDatepicker.titles.periodModifier-datepicker' | translate
      }}
    </mat-option>
  </mat-select>
</mat-form-field>

<mat-form-field class="datepicker" [class.hidden]="!isDatePickerMode">
  <mat-date-range-input [rangePicker]="picker" class="datepicker">
    <input
      matStartDate
      [(ngModel)]="start"
      [max]="end"
      (ngModelChange)="onStartChange()"
    />
    <input
      matEndDate
      [(ngModel)]="end"
      [min]="start"
      [max]="maxEndDate"
      (ngModelChange)="onEndChange()"
    />
  </mat-date-range-input>
  <mat-date-range-picker #picker></mat-date-range-picker>
</mat-form-field>
